import { render, staticRenderFns } from "./RealTimePresenceMain.vue?vue&type=template&id=0e7b9a65"
import script from "./RealTimePresenceMain.vue?vue&type=script&lang=js"
export * from "./RealTimePresenceMain.vue?vue&type=script&lang=js"
import style0 from "./RealTimePresenceMain.vue?vue&type=style&index=0&id=0e7b9a65&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports